module.exports = __webpack_public_path__ + "assets/6ffcdede88209dbedef1ae1a788f1423.png";